module.exports = __webpack_public_path__ + "static/media/Acheive6.07d18482.jpg";